import {injectable} from "inversify";

@injectable()
export abstract class ContractsRepository {
    public abstract getSignUpContract(): Promise<string>;
}
